import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";  

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const InvoiceCharge = (props) => {

    const { charges, setCharges, selectedCurrency, validated } = props;

    const { api, userData, settingData, currencyOptions, wareHouseData, selectedCompany,
        productData, refData, branchData, projectData,
        currencyData, formLanguages } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role;
    const defaultCurrency = userRole.defaultCurrency;
    const createdBy = parseInt(userData.id);


    const [loadingEffect, setLoadingEffect] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);



    const chargeItem = {
        total: 0,
        details: '',
    };


    // Add new row
    const handleAddRow = (type) => {
        if (type == 'charge') {
            setCharges([...charges, chargeItem]);
        }

    };

    // Delete VarientRow
    const handleDeleteRow = (event, type) => {
        event.preventDefault()
        const updatedRows = charges.slice(0, -1);
        setCharges(updatedRows);
    };


    // handle charges changes
    const handleChargesChange = (index, value, field) => {
        const updatedCharges = [...charges];
        
        if (field == 'total') {
            updatedCharges[index].total = parseFloat(value);
        }
        else if (field == 'details') {
            updatedCharges[index].details = value;
        }
        setCharges(updatedCharges);
    }






    return (

        <div>

            <Row className="g-0">
                <Col md={7}>
                    <Form.Label>{formLanguages.Details}</Form.Label>
                </Col>

                <Col>
                    <Form.Label>{formLanguages.Charges}</Form.Label>
                </Col>

            </Row>



            {charges.map((row, index) => (

                <Row className="g-0" key={index}>


                    {/* Details */}
                    <Col md={7}>
                        <Form.Control as="textarea" rows={1}
                            value={charges[index].details}
                            onChange={(e) => handleChargesChange(index, e.target.value, 'details')}
                            required
                        />
                    </Col>

                    {/*  total  */}
                    <Col>
                        <Form.Control type="number" min={0} step='any'
                            onChange={(e) => handleChargesChange(index, e.target.value, 'total')}
                            value={charges[index].total}
                            required
                        />
                    </Col>

                </Row>

            ))}

            <Row className="mb-0" style={{ width: '99%', marginTop: '10px' }}>
                <Col
                    style={{ marginLeft: '20%' }}
                >
                    <FcPlus size={26} style={{ cursor: 'pointer' }} onClick={() => handleAddRow('charge')} />
                    <HiMinusCircle size={28} style={{ cursor: 'pointer' }} onClick={(e) => handleDeleteRow(e, 'charge')} />

                </Col>
            </Row>

        </div>

    )
}


export default InvoiceCharge;